import createCRUDActionType from '../../helpers/create-crud-action-type';
import createTransaction from '../../helpers/create-transaction';

function startAction(actionType, data) {
  return {
    type: `${actionType}_START`,
    data,
  };
}

function finishAction(actionType, data) {
  return {
    type: `${actionType}_FINISH`,
    data,
  };
}

function failAction(actionType, error) {
  return {
    type: `${actionType}_FAIL`,
    error,
  };
}

export default function generateCRUDActionCreator(name, verb) {
  const actionType = createCRUDActionType(name, verb);

  return function CRUDActionCreator(data) {
    return dispatch => {
      dispatch(startAction(actionType, data));

      return createTransaction(name, verb, data)
        .then(response => {
          const resourceName = data.resource;
          const responseData = { [resourceName]: {} };

          if (response.value instanceof Array) {
            responseData[resourceName] = response.value.reduce(
              (acc, item) => ({
                ...acc,
                [item.id]: item,
              }),
              {}
            );
          } else {
            responseData[resourceName] = { [response.value.id]: response.value };
          }

          dispatch(
            finishAction(actionType, {
              resource: resourceName,
              response: responseData,
            })
          );
        })
        .catch(error => {
          if (error instanceof Error) {
            throw error;
          }
          dispatch(failAction(actionType, error));
        });
    };
  };
}
